/* ar-brown App (C) 2021 arbrown.co.jp All rights reserved.
 *******************************************************************************
 * Program ID:  Agent.js
 * $Revision:   Ver1.0
 * $Modtime:    $
 *******************************************************************************
 * Author      (作成／更新年月日、担当者)
 *  2021/08/01 Rayoo)li : 新規作成
 *
 * Summary Agent画面
 *
 * Instructions / Preconditions
 *  なし
 *
 *******************************************************************************
 */
 import React, { useEffect, useState } from "react";
 /*  GraphQL API Acess */
 import API, { graphqlOperation } from "@aws-amplify/api";
 import {listArOrderRecipients} from "../graphql/queries";
 /*  AWS標準設定 with Login Auth. */
 import Amplify,{Auth} from "aws-amplify";
 import awsconfig from "../aws-exports";
 Amplify.configure(awsconfig);
import { Container,Row,Col,InputGroup } from "react-bootstrap";
 import BootstrapTable from "react-bootstrap-table-next";
 import paginationFactory from "react-bootstrap-table2-paginator";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:"80%"
  },
  textlabelSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:"20%"
  }
}));
 const customTotal = (from, to, size) => (
   <span
     style={{ marginLeft: "1em" }}
     className="react-bootstrap-table-pagination-total"
   >
     {size} の結果の {from} から {to} を表示しています
   </span>
 );
 const pageButtonRenderer = ({ page, onPageChange }) => {
   const handleClick = (e) => {
     e.preventDefault();
     onPageChange(page);
   };
   return (
     <button className="btn-secondary btn" type="button" key={page}>
       <li className="page-item">
         <a style={{ color: "white" }} href="#" onClick={handleClick}>
           {page}
         </a>
       </li>
     </button>
   );
 };
 const sizePerPageRenderer = ({
   options,
   currSizePerPage,
   onSizePerPageChange,
 }) => (
     <div className="btn-group" role="group">
       {options.map((option) => (
         <button
           key={option.text}
           type="button"
           onClick={() => onSizePerPageChange(option.page)}
           className={`btn ${
             currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"
             }`}
         >
           {option.text}
         </button>
       ))}
     </div>
   );
 const options = {
   paginationSize: 10,
   pageStartIndex: 1,
   showTotal: true,
   withFirstAndLast: true,
   firstPageText: "最初",
   prePageText: "戻る",
   nextPageText: "次へ",
   lastPageText: "最後",
   nextPageTitle: "最初のページ",
   prePageTitle: "プレページ",
   firstPageTitle: "次のページ",
   lastPageTitle: "最後のページ",
   paginationTotalRenderer: customTotal,
   sizePerPageRenderer: sizePerPageRenderer,
   pageButtonRenderer: pageButtonRenderer,
   disablePageTitle: true,
   sizePerPageList: [
     {
       text: "10",
       value: 10,
     },
     {
       text: "20",
       value: 20,
     },
     {
       text: "30",
       value: 30,
     },
   ],
 };
 export const OrderRecipient = () => {
   const [orderRecipientList, setOrderRecipientList] = useState([]);
  const [progress, setProgress] = useState(false);
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState({
    OrderReceiptCode: "",
    UsageSuspendReason : ""
  })
  const searchOrderReceiptCodeChange = (e, value) => {
    setSearchValue({ ...searchValue, OrderReceiptCode: value ? value.split(":")[0] : "" })
  }
  const searchUsageSuspendReasonListChange = (e, value) => {
    setSearchValue({ ...searchValue, UsageSuspendReason: value ? value : "" })
  }
  const [OrderReceiptCodeList, setOrderReceiptCodeList] = useState([])
  const [UsageSuspendReasonList, setUsageSuspendReasonList] = useState([])
  async function searchData() {
    let dataAll = [];
  try {
    const orderRecipientInfo = await API.graphql(
      graphqlOperation(listArOrderRecipients, { limit: 10000 })
    );
    if (orderRecipientInfo.data.listArOrderRecipients !== null) {
      dataAll =
         orderRecipientInfo.data.listArOrderRecipients.items;
       let nextToken =
         orderRecipientInfo.data.listArOrderRecipients.nextToken;
      while (nextToken !== null) {
        let InvDataSec = await API.graphql(
          graphqlOperation(listArOrderRecipients, {
            limit: 10000,
            nextToken: nextToken,
           })
         );
        if (InvDataSec.data.listArOrderRecipients !== null) {
          nextToken = InvDataSec.data.listArOrderRecipients.nextToken;
          for (
            let i = 0;
            i < InvDataSec.data.listArOrderRecipients.items.length;
            i++
          ) {
            dataAll.push(
               InvDataSec.data.listArOrderRecipients.items[i]
             );
          }
        }
      }
    }
} catch (err) {
  console.log(err);
}
  return dataAll
  }
  const getTypePriority = (str) => {
    if (!str || str.trim() === "") return 99;
    const firstChar = str[0];
    if (/^[0-9]/.test(firstChar)) return 1;
    if (/^[a-zA-Z]/.test(firstChar)) return 2;
    if (/^[\u30A0-\u30FF]/.test(firstChar)) return 3;
    if (/^[\u3040-\u309F\u4E00-\u9FFF]/.test(firstChar)) return 4;
    return 5;
  };
  const sortByOrderRecipientName2 = (a, b) => {
    const nameA = a.OrderRecipientName2 || "";
    const nameB = b.OrderRecipientName2 || "";
    const priorityA = getTypePriority(nameA);
    const priorityB = getTypePriority(nameB);
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  };
  const sortByOrderRecipientName3 = (a, b) => {
    const nameA = a.OrderRecipientName3 || "";
    const nameB = b.OrderRecipientName3 || "";
    const priorityA = getTypePriority(nameA);
    const priorityB = getTypePriority(nameB);
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  };
  const multiSort = (arr, ...sortFuncs)=> {
    return arr.sort((a, b) => {
      for (const func of sortFuncs) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
  const searchBtn = async () => {
    setProgress(true)
    let arr = [];
    let dataAll = [];
    let obj = {};
    try {
      dataAll = await searchData()
      } catch (error) {
      console.log(error);
      }
      obj = searchValue;
      dataAll.forEach(item => {
        let flag = true
        if (Object.keys(obj).length !== 0) {
          for (let name in obj) {
            if (obj[name] !== "") {
              if (item[name]) {
                if (!(item[name]).includes(obj[name])) {
                  flag = false;
                  break;
                }
              } else {
                flag = false
                break;
              }
            }
          }
        }
        if (flag === true) {
          arr.push(item)
        }
      })
      arr = multiSort(arr,sortByOrderRecipientName2,sortByOrderRecipientName3)
      setOrderRecipientList(arr);
      setProgress(false)
  }
  const searchClear = async()=>{
      setProgress(true)
      let arr = [];
      try {
        arr = await searchData()
        } catch (error) {
          if (error.message === 'No current user') {
              //ユーザープールに障害が発生した場合
              console.log('User pool is invalid.Please reauthenticate.');
              //ログイン画面に戻る
              signOut();
          } else {
              //他のエラーを処理する
              console.log('An error occurred:', error);
          }
        }
        arr = multiSort(arr,sortByOrderRecipientName2,sortByOrderRecipientName3)
        setSearchValue({OrderReceiptCode: "",UsageSuspendReason:""})
        setOrderRecipientList(arr);
        setProgress(false)
  }
  const signOut = async () => {
    await Auth.signOut();
    try {
        await Auth.signOut();
    } catch (error) {
        console.log("error signing out: ", error);
    }
    document.location.reload();
  };
    const [scrollTableWidth,setscrollTableWidth] = useState('101%')
    function calculateZoomLevel() {
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const zoomLevel = ((windowWidth / screenWidth) + (windowHeight / screenHeight)) / 2;
      return Math.round(zoomLevel * 100);
    }
  useEffect(() => {
    let lastZoomLevel = calculateZoomLevel();
     async function getOrderRecipientList() {
      let orderRecipientArr = [];
      let orderReceiptCodeList = []
      let usageSuspendReasonList = []
      setProgress(true);
       try{
       const orderRecipientInfo = await API.graphql(
         graphqlOperation(listArOrderRecipients, { limit: 10000 })
       );
       if (orderRecipientInfo.data.listArOrderRecipients !== null) {
          orderRecipientArr =
            orderRecipientInfo.data.listArOrderRecipients.items;
          let nextToken =
            orderRecipientInfo.data.listArOrderRecipients.nextToken;
         while (nextToken !== null) {
           let InvDataSec = await API.graphql(
             graphqlOperation(listArOrderRecipients, {
               limit: 10000,
               nextToken: nextToken,
              })
            );
           if (InvDataSec.data.listArOrderRecipients !== null) {
             nextToken = InvDataSec.data.listArOrderRecipients.nextToken;
             for (
               let i = 0;
               i < InvDataSec.data.listArOrderRecipients.items.length;
               i++
             ) {
                orderRecipientArr.push(
                  InvDataSec.data.listArOrderRecipients.items[i]
                );
             }
           }
         }
       }
    }catch(err){
        console.log(err);
    }
    for (let i = 0; i < orderRecipientArr.length; i++) {
      if (orderRecipientArr[i].OrderReceiptCode) {
        orderReceiptCodeList.push(orderRecipientArr[i].OrderReceiptCode + ":" + orderRecipientArr[i].OrderRecipientName2 + " " + orderRecipientArr[i].OrderRecipientName3 + " " + orderRecipientArr[i].OrderRecipientName4)
        usageSuspendReasonList.push(orderRecipientArr[i].UsageSuspendReason)
      }
    }
    orderRecipientArr = multiSort(orderRecipientArr,sortByOrderRecipientName2,sortByOrderRecipientName3)
       setOrderReceiptCodeList(Array.from(new Set(orderReceiptCodeList)))
       setUsageSuspendReasonList(Array.from(new Set(usageSuspendReasonList)))
       setOrderRecipientList(orderRecipientArr);
      setProgress(false);
      const handleResize = () => {
        let dom = document.querySelector("#table");
        const newZoomLevel = calculateZoomLevel();
        if (lastZoomLevel !== newZoomLevel) {
          if (newZoomLevel > lastZoomLevel) {
            setscrollTableWidth(dom ? `101%` : `101%`)
          }else {
            let width = dom ? (`${dom.offsetWidth}` < 1632 ? `1632px` : '101%') : '101%';
            setscrollTableWidth(`${width}`)
          }
          lastZoomLevel = newZoomLevel;
        }
      };
      window.addEventListener('resize',handleResize, 100);
      return () => window.removeEventListener('resize', handleResize);
       }
    getOrderRecipientList();
   }, []);
   const headerStyle = {
     backgroundColor: "white",
     borderBottom: "3px solid #B45210",
   };
   let columns1 = [
     { dataField: "id", text: "ID", hidden: true },
    {
      dataField: "OrderReceiptCode",
      text: "受注先",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "80px",minWidth:"80px"},
    },
    {
      dataField: "OrderRecipientName2",
      text: "受注先マスタ_名称２",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "260px",minWidth:"260px" },
    },
    {
      dataField: "OrderRecipientName3",
      text: "受注先マスタ_名称３",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "200px",minWidth:"200px" },
    },
    {
      dataField: "OrderRecipientName4",
      text: "受注先マスタ_名称４",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "200px",minWidth:"200px" },
    },
    {
      dataField: "UsageSuspendReason",
      text: "取引先マスタ_利用停止理由",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "230px",minWidth:"230px" },
    },
   ];
   return (
     <Container
       style={{ backgroundColor: "", minWidth: "100%", minHeight: "74vh" }}
     >
      <Row
        style={{
           borderRadius: "0.25em",
           color: "purple",
           padding: "0.5em",
            }}
          >
        <div style={{ display: 'flex', marginBottom: "10px",width:"100%"}}>
        <Col>
            <h4 style={{
               textAlign: "left",
               color: "black",
               height: 30,
               width: '20%',
               borderLeft: "4px solid #804F29",
               paddingLeft: "4px",
               whiteSpace:"nowrap"}}>
                受注先マスタ
            </h4>
        </Col>
        <div style={{ width: '80%', height: 140 }}>
          <div style={{ width: '90%',minWidth:"500",height: 140, border: '2px solid rgb(191,191,191)', display:'flex', flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >受注先コード
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                    options={OrderReceiptCodeList}
                    value={searchValue.OrderReceiptCode}
                    maxLength ="20"
                    onChange={(e, value) => { searchOrderReceiptCodeChange(e, value) }}
                    name="OrderReceiptCode"
                    id="OrderReceiptCode"
                    isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"180px"}}
                  >取引先マスタ_利用停止理由
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                    options={UsageSuspendReasonList}
                    value={searchValue.UsageSuspendReason}
                    maxLength ="20"
                    onChange={(e, value) => { searchUsageSuspendReasonListChange(e, value) }}
                    name="UsageSuspendReason"
                    id="UsageSuspendReason"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{margin:"auto"}}>
               <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                 <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
             </div>
          </div>
        </div>
        </div>
      </Row>
      <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
              <div style={{ direction: "ltr" }}>
           <BootstrapTable
           id="table"
             striped={true}
             hover={true}
             wrapperClasses="boo bg-white"
             bootstrap4
             keyField="id"
             data={orderRecipientList}
             columns={columns1}
             noDataIndication={"no results found"}
             pagination={paginationFactory(options)}
             headerClasses={classes.fixedTop}
             />
           </div>
           </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "55%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress
          size="3rem"
          disableShrink
          sx={{
            color: "#3f51b5",
            margin: "auto",
            display: progress ? "block" : "none",
            marginLeft: "60px",
          }}
        />
    </div>
     </Container>
   );
 };
 export default OrderRecipient;